import { createFileRoute, notFound } from '@tanstack/react-router'
import { ResourceArticlePage } from '@/features/resources/components/resource-article-page'
import { findPublishedResourceByPath } from '@/features/resources/content/resources'
import { buildResourceHead } from '@/features/resources/seo/resource-seo'

export const Route = createFileRoute('/$lang/resources/$category/$slug')({
  beforeLoad: ({ params }) => {
    requirePublishedResource(params.category, params.slug)
  },
  loader: ({ params }) =>
    requirePublishedResource(params.category, params.slug),
  head: ({ params }) =>
    buildResourceHead(requirePublishedResource(params.category, params.slug)),
  component: ResourceRouteComponent,
  staticData: { layout: 'public' },
})

function ResourceRouteComponent() {
  const resource = Route.useLoaderData()
  return <ResourceArticlePage resource={resource} />
}

function requirePublishedResource(category: string, slug: string) {
  const resource = findPublishedResourceByPath(category, slug, 'ru')
  if (!resource) throw notFound()
  return resource
}
